import { useMutation } from "react-query";
import { updateLeasedEquipmentMake } from "../../../../../actions/Utilities/LeasedEquipmentMake";
import { toast } from "components/toastNotification";
import { IMake } from "../types";

const useEditMake = () => {
  const { mutate } = useMutation(
    (Data: IMake) => updateLeasedEquipmentMake(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Make Updated Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Make Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Make failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Make failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Updating Make failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Updating Make failed", `${res.Message}`, "error");
        }
      },
      onError: (error: any) => {
        toast.fire("Update Make failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditMake;
